var Component = require("!../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../node_modules/vue-loader/lib/selector?type=script&index=0!./RefreshAndInfinite.vue"),
  /* template */
  require("!!../../node_modules/vue-loader/lib/template-compiler/index?{\"id\":\"data-v-1217a566\"}!../../node_modules/vue-loader/lib/selector?type=template&index=0!./RefreshAndInfinite.vue"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./demo/components/RefreshAndInfinite.vue
// module id = 12
// module chunks = 0